<div class="flex select-none flex-col gap-1">
    <h2 class="m-0 text-xl font-normal text-[var(--color-text-strong)]">
        {{ title() || ('general.scd-picker.dialog.title' | translate) }}
    </h2>
    <p class="m-0 text-base text-[var(--color-text-subtle)]">{{ text() }}</p>
</div>
